import React, { useState,useEffect,useRef }  from 'react';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import { BrowserRouter as Router, useNavigate,useParams  } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Common,{Server,Server2,AlphabetOnly,NumericOnly,logoutButton,download,LoadingDialog,ErrorDialog,Topbar,CallAPI,GetData, ConsoleLog,Server3,CallDvrAPI,redirectToNew,emptyCache,ConfirmDialog} from './commonfunction';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from "@mui/material/Grid";

const DialogTitle = (props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography style={{
      margin: 0,
      padding: 15,
    }} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" style={{
          position: 'absolute',
          right: 2,
          top: 2,
          color: "#888888",
        }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};


function App(props) {
  //const { id } = useParams();
  //ConsoleLog(id);
  let navigate = useNavigate();
  const [error, setError] = useState(false);
  const [openComfirm, setOpenComfirm] = useState(false);
  const [errorNo, setErrorNo] = useState("400");

  const [CMID,setCMID] = useState("")
  const [StudentName, setStudentName] = useState("");
  const CMIDRefs = useRef()
  const StudentNameRefs = useRef()
  const [StudentLabelList1, SetStudentLabelList1] = useState([]);
  const [StudentLabelList2, SetStudentLabelList2] = useState([]);
  const [SelectCMID, SetSelectCMID] = useState("");
  const tableHeight = 56;
  const [AssignBus, SetAssignBus] = useState("");
  const [BusBoarded, SetBusBoarded] = useState("");
  const [ClassNo, SetClassNo] = useState("");
  const [ParentContact, SetParentContact] = useState("");
  const [Spot, SetSpot] = useState("");
  const linkrerfs = useRef();

  useEffect(
    () => {
      const interval = setTimeout(() => {
        GetStudent_AttendApp()
      }, 200);
      return () => clearTimeout(interval)
    }
  ,[]);//,[] make it run only once

  /*
    StudentID: "CISXXXXX"
    StudentName: "ABC"
  */
  function GetStudent_AttendApp(){
    //var para0 = JSON.stringify({token:localStorage.getItem('StAttApptoken')});
    var para2 = "action=GetStudent_AttendApp";
    var para3 = para2  +"&token="+localStorage.getItem('StAttApptoken')// + "&itemObject=" + para0;
    GetData(para3,
        data => {
            //ConsoleLog(data)
          if(data["result"] === "200"){
            if(`${data["list"]}`.length > 10){
                var list = JSON.parse(data["list"])
                var templist1=[]
                var templist2=[]
                for(var k=0;k<list.length;k++){
                    templist1.push({label:list[k]["StudentID"]+":"+list[k]["StudentName"],value1:list[k]["StudentID"],value2:list[k]["StudentName"]})
                    templist2.push({label:list[k]["StudentID"]+":"+list[k]["StudentName"],value1:list[k]["StudentID"],value2:list[k]["StudentName"]})
                }
                SetStudentLabelList1(templist1)
                SetStudentLabelList2(templist2)
            }
          }else if(data["result"] === "201"){
            setErrorNo("201");
            setError(true);
          }else{
            setErrorNo("400");
            setError(true);
          }
        }
      );
  }
/*
AppUserPhone
AssignedBus
BusBoarded
ClassNo
DropOffPoint
PickUpPoint
StudentID
 GetOnDatetime
*/
  function GetStudentAttendance_AttendApp(studentID){
    var para0 = JSON.stringify({StudentID:studentID});
    var para2 = "action=GetStudentAttendance_AttendApp";
    var para3 = para2 +"&token="+localStorage.getItem('StAttApptoken') + "&itemObject=" + para0;
    GetData(para3,
        data => {
           // ConsoleLog(data)
            if(data["result"] === "200"){
                if(`${data["list"]}`.length > 10){
                    var list = JSON.parse(data["list"])
                    SetAssignBus(list[0]["AssignedBus"]);
                    SetBusBoarded(list[0]["BusBoarded"]);
                    SetClassNo(list[0]["ClassNo"]);
                    SetParentContact(list[0]["AppUserPhone"]);
                    SetSpot("上車地點: "+list[0]["PickUpPoint"]+"\n"+"落車地點: "+list[0]["DropOffPoint"]+"\n\n"+(`${list[0]["GetOnDatetime"]}`.includes("2000")?"":(`拍卡時間:`+`${list[0]["GetOnDatetime"]}`.substring(11,16))));
                    //ConsoleLog(list)
                }
            }else if(data["result"] === "201"){
                setErrorNo("201");
                setError(true);
            }else{
            setErrorNo("400");
            setError(true);
            }
        }
        );
  }
  
    //const layout = [];
    //layout.push(<div>{"CMID (Student)"}</div>);
    //layout.push(<TextField inputRef={CMIDRefs} value={CMID} variant="outlined" margin="normal" required fullWidth id="cmidfield" name="cmidfield" key="cmidfieldKey" autoComplete="user" autoFocus style={{height:50}} onChange={(e)=>{setCMID(e.target.value)}}/>);
    //layout.push(<Autocomplete disablePortal id="combo-box-demo1" options={StudentLabelList1} sx={{ width: "100%" }} renderInput={(params) => <TextField {...params}/>} onChange={(e,value)=>{if(value !== null){ConsoleLog(`${value.value1}`);SetSelectCMID(`${value.value1}`)}else{ConsoleLog(`${null}`);}}}/>);
    //layout.push(<div>Student</div>);
    //layout.push(<TextField inputRef={StudentNameRefs} value={StudentName} variant="outlined" margin="normal" required fullWidth id="passwordfield" name="studentfield" key="studentfieldKey" autoComplete="current-password" style={{height:50}} onChange={(e)=>{setStudentName(e.target.value)}}/>);
    //layout.push(<Autocomplete disablePortal id="combo-box-demo2" options={StudentLabelList2} sx={{ width: "100%" }} renderInput={(params) => <TextField {...params} label="Student"/>} onChange={(e,value)=>{ConsoleLog(value.value1);SetSelectCMID(value.value1)}}/>);
    //layout.push(<FormControlLabel control={<Checkbox checked={remember} inputRef={rememberCheckBox} name="rememberCheckBox" key="rememberCheckBoxKey" color="primary"/>} label="Save Login Information"  onChange={()=>{}}/>);
    //<tr style={{height:tableHeight}}><Button disabled={false} value={ParentContact} sx={{width:"100%",height:tableHeight,"& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",},}} variant="outlined">{ParentContact}</Button></tr>
    //                        <tr style={{height:tableHeight}}><a href={`tel:${ParentContact}`} refs={linkrerfs} disabled={false} value={ParentContact} sx={{width:"100%",height:tableHeight,"& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",},}} variant="outlined">{ParentContact}</a></tr>
    return (

      <div style={{backgroundImage:'url("image/CityMotorsBackGround.png")',backgroundSize:'cover',backgroundRepeat:'no-repeat',height:'100vh',width:'100%',marginTop:'0vh',overflow:"scroll",msOverflowStyle:'none',scrollbarWidth:'none'}}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div style={{height:'96vh'}}>
              <div style={{height:85 , background:"#FFFFFF", width: '100%' }}>
                <img style={{height:85,marginTop:5}} src="image/CityMotors2.png"/>
              </div>
              <div style={{ paddingLeft:'1%',paddingRight:'1%',
                            display:'block', position: 'relative',
                            
                            width: '100%',
                            borderRadius: '10px',
                            overflow:"scroll",msOverflowStyle:'none',scrollbarWidth:'none',overflow: 'hidden'}}>
                  <div style={{marginTop:30,width: '100%',}}>
                  </div>
                  <div>{"CMID/Student Name"}</div>
                  <Autocomplete disablePortal id="combo-box-demo1" options={StudentLabelList1} sx={{ width: "100%" }} renderInput={(params) => <TextField {...params}/>} onChange={(e,value)=>{if(value !== null){ConsoleLog(`${value.value1}`);SetSelectCMID(`${value.value1}`)}else{ConsoleLog(`${null}`);}}}/>
                  <Button type="submit" fullWidth variant="contained" style={{color: "#FFFFFF",background: "#77933C",height:50,marginTop:20,marginBottom:10}}
                    onClick={
                      ()=>{
                        GetStudentAttendance_AttendApp(SelectCMID)
                      }
                    }
                  >
                    Search Student
                  </Button>
                  <Grid container spacing={0}>
                    <Grid item xs={6}>
                        <table>
                        <tr style={{}}><div>Assigned Route</div></tr>
                        <tr style={{height:tableHeight+20}}><TextField multiline minRows={2} maxRows={2} disabled={true} 
                                                            value={AssignBus.replace("(","\n(")} 
                                                            sx={{fontWeight:"bold",width:"100%",height:tableHeight
                                                            ,"& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",fontWeight:"bold"}
                                                            ,"& .css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root":{padding:1}}} 
                                                            inputProps={{min: 0, style: { padding:0,fontSize:24,textAlign: 'center' }}}
                                                            variant="outlined" /></tr>
                        <tr style={{}}><div style={{marginTop:1}}>Class No</div></tr>
                        <tr style={{height:tableHeight+15}}><TextField disabled={true} value={ClassNo} 
                                                            sx={{marginTop:0,fontWeight:"bold",width:"100%",height:tableHeight,"& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",fontWeight:"bold"},}} 
                                                            inputProps={{min: 0, style: { padding:11,fontSize:24,textAlign: 'center' }}}
                                                            variant="outlined" /></tr>
                        </table>
                    </Grid>
                    <Grid item xs={6}>
                        <table>
                        <tr style={{}}><div style={{marginTop:1}}>Route Boarded</div></tr>
                        <tr style={{height:tableHeight+20}}><TextField  multiline minRows={2} maxRows={2}  disabled={true} 
                                                            value={BusBoarded.replace("(","\n(")} 
                                                            sx={{fontWeight:"bold",width:"100%",height:tableHeight
                                                            ,"& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",fontWeight:"bold"}
                                                            ,"& .css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root":{padding:1}}} 
                                                            inputProps={{min: 0, style: { padding:0,fontSize:24,textAlign: 'center' }}}
                                                            variant="outlined" /></tr>
                        <tr style={{}}><div>{`Parent Contact`} <span style={{fontSize:11}}>{`(Press to call)`}</span></div></tr>
                        <tr style={{height:tableHeight+15}}><Button disabled={false} value={ParentContact} 
                                                            sx={{marginTop:0,fontWeight:"bold",fontSize:24,width:"100%",height:tableHeight,"& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",},}} 
                                                            variant="outlined" onClick={()=>{
                            
                            setOpenComfirm(true);
                        }}>{ParentContact}</Button></tr>
                        </table>
                    </Grid>
                    <Grid item xs={12}>
                        <div>Pick-up/Drop-off Spot</div>
                        <TextField disabled={true} value={Spot} multiline minRows={4} maxRows={4} sx={{fontWeight:"bold",width:"100%","& .MuiInputBase-input.Mui-disabled": {WebkitTextFillColor: "#000000",fontWeight:"bold"},}} variant="outlined" />
                    </Grid>
                    </Grid>
                  <Button type="submit" fullWidth variant="contained" style={{color: "#FFFFFF",background: "#E46C0A",height:50,marginTop:20}}
                    onClick={
                      ()=>{
                        navigate("/")
                      }
                    }
                  >
                    Sign Out
                  </Button>

              </div>
          </div>
        </Container>
        {ErrorDialog(errorNo,error,()=>{setError(false);})}
        {ConfirmDialog(openComfirm,'Call '+ParentContact +"?",()=>{setOpenComfirm(false)},()=>{window.open('tel:'+ParentContact, '_system');setOpenComfirm(false)})}
      </div>
      //   </Switch>
      //   <Route path="/tabs">
      //       <SimpleTabs />
      //     </Route>
      //     <Route path="/tabs2">
      //       <SimpleList />
      //     </Route>
      // </Router>
    );
}




export default App;